/**
 * @name coerceBoolean
 * @deprecated This utility is deprecated and will be removed in the next major version.
 * @description Translates a value to its boolean representation
 *
 * @example
 * import { coerceBoolean } from '@workbench/core';
 *
 * coerceBoolean(true); // true
 * coerceBoolean(false); // false
 * coerceBoolean('true'); // true
 * coerceBoolean('false'); // false
 * coerceBoolean('something'); // true
 * coerceBoolean(''); // true
 * coerceBoolean(1); // true
 * coerceBoolean(0); // false
 * coerceBoolean(undefined); // false
 * coerceBoolean(null); // false
 */
export function coerceBoolean(value: unknown): boolean {
  if (value === 0 || value === undefined || value === null) {
    return false;
  } else if (value === true || value === false) {
    return Boolean(value);
  } else if (value === 'false') {
    return false;
  } else {
    return true;
  }
}
